function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.389 11.847a3.273 3.273 0 0 1 2.52-1.21 3.273 3.273 0 1 1-3.273 3.272 3.41 3.41 0 0 1 .057-.58l-4.32-1.989a3.273 3.273 0 1 1 0-4.68l4.32-1.988a3.273 3.273 0 1 1 .695 1.48L7.217 8.077c.196.6.196 1.248 0 1.849l4.173 1.922zm4.156-7.756a1.636 1.636 0 1 0-3.273 0 1.636 1.636 0 0 0 3.273 0zM4.091 10.636a1.636 1.636 0 1 1 0-3.272 1.636 1.636 0 0 1 0 3.272zm8.181 3.273a1.636 1.636 0 1 0 3.273 0 1.636 1.636 0 0 0-3.273 0z",
  fill: "#5B5C64"
});

var SvgIconShare = function SvgIconShare(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconShare, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-share.15b67ea7.svg";
export { ForwardRef as ReactComponent };